import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";

const Tab = ({ selectedTab, children, index, ...props }) => (
  <div role="tabpanel" hidden={selectedTab !== index} {...props}>
    {selectedTab === index && <Box p={3}>{children}</Box>}
  </div>
);

Tab.propTypes = {
  /**
   * Índice de la pestaña seleccionada
   **/
  selectedTab: PropTypes.number,
  /**
   * Índice de la pestaña a renderizar
   **/
  index: PropTypes.number,
  /**
   * Índice de la pestaña seleccionada
   **/
  value: PropTypes.number,
};

export default Tab;
